import React, { useState, useEffect } from "react";
import { useTranslation } from "../../hooks/translation";
import { useNavigate, useLocation } from "react-router-dom";
import "./navigation.css";

interface NavigationProps {
  lang: string;
}

export const Navigation: React.FC<NavigationProps> = ({ lang }) => {
  const [activeSection, setActiveSection] = useState<string>("");
  const [menuOpen, setMenuOpen] = useState<boolean>(false);
  const [scrolled, setScrolled] = useState<boolean>(false);
  const { t } = useTranslation(lang);

  const scrollOffset = 400;
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      const passed = window.scrollY > scrollOffset;
      setScrolled((prev) => (prev !== passed ? passed : prev));

      const sections = ["landing", "studio", "services", "blog", "contact"];
      for (let id of sections) {
        const el = document.getElementById(id);
        if (el) {
          const rect = el.getBoundingClientRect();
          if (rect.top <= 100 && rect.bottom >= 100) {
            setActiveSection(id);
            break;
          }
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleLanguageChange = (newLang: string) => {
    const anchor = location.hash;
    navigate(`/${newLang}${anchor}`);
  };

  return (
    <nav className="main-nav">
      <div className="nav-inner">
        <a href="#landing" className="nav-logo">
          <img src={scrolled ? "/img/lftr-colors.png" : "/img/lftr-bn.png"} alt="LIFTER Logo" />
        </a>

        <button className="menu-toggle" onClick={() => setMenuOpen(!menuOpen)} aria-label="Toggle menu">
          <span className="bar" />
          <span className="bar" />
          <span className="bar" />
        </button>

        <ul className={`nav-links ${menuOpen ? "open" : ""}`}>
          <li>
            <a href="#studio" className={activeSection === "studio" ? "active" : ""}>
              {t("nav.studio")}
            </a>
          </li>
          <li>
            <a href="#services" className={activeSection === "services" ? "active" : ""}>
              {t("nav.services")}
            </a>
          </li>
          {/* <li>
            <a href="#blog" className={activeSection === "blog" ? "active" : ""}>
              {t("nav.articles")}
            </a>
          </li> */}
          <li>
            <a href="#contact" className={activeSection === "contact" ? "active" : ""}>
              {t("nav.contact")}
            </a>
          </li>
		  <li className="lang-switch">
			<button onClick={() => handleLanguageChange(lang === "en" ? "es" : "en")}>
				{lang === "en" ? (
				<>
					ESP
				</>
				) : (
				<>
					ENG
				</>
				)}
			</button>
			</li>
        </ul>
      </div>
    </nav>
  );
};
